import React from 'react'
import Navbar from './Navbar'

function Page404() {
    return (
        <div>
            <Navbar />
            <h1 style={{textAlign:"center"}} >404 - Page Does Not Exist</h1>
        </div>
    )
}

export default Page404
